// removed by extract-text-webpack-plugin
module.exports = {"FakeBrowser":"FakeBrowser---1GwS6","TopBar":"TopBar---k-56v","AddressBar":"AddressBar---3mzTQ","ViewPort":"ViewPort---1Putb"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/UserProfile/Sections/Profile/ThemeInfo/FakeBrowser/styles.styl
// module id = O13t
// module chunks = 89